document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("modal-close").addEventListener("click", function () {
    document.getElementById("calendar-modal").classList.remove("is-open");
  });

  document
    .querySelector(".calendar-modal__overlay")
    .addEventListener("click", function () {
      document.getElementById("calendar-modal").classList.remove("is-open");
    });

  const calendarEl = document.getElementById("calendar");
  if (!calendarEl) return;

  const calendar = new FullCalendar.Calendar(calendarEl, {
    initialView: "dayGridMonth",
    locale: "ja",
    height: "auto",
    eventDisplay: "block",
    dayMaxEvents: true,
    fixedWeekCount: false,

    buttonText: {
      today: "今日",
    },

    dayCellContent: function (arg) {
      return arg.date.getDate();
    },
    dayCellClassNames: function (arg) {
      const day = arg.date.getDay();

      if (day === 0) return ["is-sunday"];
      if (day === 6) return ["is-saturday"];

      return [];
    },

    googleCalendarApiKey: "AIzaSyDjdsjnuJhuvgr2537t4--mX8cbeiGQuU8", //APIキー

    eventSources: [
      {
        googleCalendarId:
          "12f88ae2d4a4268e850bc0d80f615bfeee2b27298b9e29e64acca95ee243f493@group.calendar.google.com", //カレンダーID
        success: function (events) {
          return events;
        },
      },
    ],

    eventClassNames: function (arg) {
      const title = arg.event.title;
      if (title.includes("休診")) return ["closed"];
      return [];
    },

    eventClick: function (info) {
      info.jsEvent.preventDefault();

      const event = info.event;
      const title = event.title;
      const date = event.start.toLocaleDateString("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      let timeText = "";
      if (!event.allDay && event.start) {
        const startTime = event.start.toLocaleTimeString("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        });
        if (event.end) {
          const endTime = event.end.toLocaleTimeString("ja-JP", {
            hour: "2-digit",
            minute: "2-digit",
          });
          timeText = `${startTime} 〜 ${endTime}`;
        } else {
          timeText = startTime;
        }
      }

      // Google Calendarの詳細情報
      const description = event.extendedProps.description || "";
      const location = event.extendedProps.location || "";

      const modal = document.getElementById("calendar-modal");
      document.getElementById("modal-date").textContent = date;
      document.getElementById("modal-title").textContent = title;

      // 時間
      const timeEl = document.getElementById("modal-time");
      if (timeEl) {
        timeEl.textContent = timeText;
        timeEl.style.display = timeText ? "" : "none";
      }

      // 場所
      const locationEl = document.getElementById("modal-location");
      if (locationEl) {
        locationEl.textContent = location;
        locationEl.style.display = location ? "" : "none";
      }

      // 説明
      const descEl = document.getElementById("modal-description");
      if (descEl) {
        descEl.innerHTML = description;
        descEl.style.display = description ? "" : "none";
      }

      modal.classList.add("is-open");
    },
  });

  calendar.render();
});
